import config from 'config';
import axios from 'axios';
import { logoutAndRedirect } from '../actions/loginActionCreators';
import { browserHistory } from 'react-router';
var baseUrl = config.baseUrl;

export const customHeader = () => {
  const authInfo = sessionStorage.getObject('auth') || localStorage.getObject('auth') || {};
  const userToken = authInfo.token;
  const customHeader = {};
  if (userToken) customHeader['ACTIVE-TOKEN'] = userToken;
  return customHeader;
};

// General
export function req(method, url, params) {
  const body = method === 'get' ? 'params' : 'data';
  const config = {
    method,
    url,
    baseURL: baseUrl,
    [body]: params || {},
    headers: customHeader()
  };
  return axios.request(config).catch(error => {
    if (error.response.status === 401 || error.response.status === 403) {
      const runName = localStorage.getItem('run');
      const currentRole = localStorage.getItem('r');
      const redirectUrl = currentRole == 0 ? `/administer/${runName}/` : `/rank/${runName}/login`;
      logoutAndRedirect();
      browserHistory.replace(redirectUrl);
      return Promise.reject(error.response);
    }
    if (error.response.status === 400) {
      return Promise.reject(error.response);
    }
    return Promise.reject('Error');
  });
}

export function get(url) {
  return axios
    .get({
      url,
      baseURL: baseUrl,
      headers: customHeader()
    })
    .then(data => {
      data;
    });
}

export function post(url, body) {
  return axios
    .post({
      url,
      baseURL: baseUrl,
      body: JSON.stringify(body),
      headers: customHeader()
    })
}

export function put(url, data) {
  return axios.request({
    url,
    method: 'PUT',
    baseURL: baseUrl,
    data,
    headers: customHeader
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js